import { keyframes } from "@emotion/css"
import styled from "@emotion/styled"

export const loadingBounce = (bounceOffset: number) => keyframes`
  0%   { transform: translateX(-${bounceOffset}px); }
  50%  { transform: translateX(${bounceOffset}px); }
  100% { transform: translateX(-${bounceOffset}px); }
`

export const fadeIn = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`

export const Loading = styled.div<{ bounceOffset: number }>`
  font-size: 25px;
  letter-spacing: 8px;
  text-align: center;
  animation: ${fadeIn} 500ms forwards,
    ${p => loadingBounce(p.bounceOffset)} 1s infinite;
`
